import * as React from 'react';
import { Icon } from '../Icon/Icon';

export interface IMobileMenuProps {
    toggledmobile: () => void;
}

interface IMobileMenuState {
    open: boolean;
}

export class MobileMenu extends React.Component<IMobileMenuProps, IMobileMenuState> {
    private didScroll = false;
    private lastScrollTop = 0;
    private delta = 5;
    private navbarHeight = 85;

    constructor(props: IMobileMenuProps) {
        super(props);
        this.state = { open: false };
    }

    public componentDidMount(): void {
        window.addEventListener('scroll', () => {
            this.didScroll = true;
        });

        setInterval(() => {
            if (this.didScroll) {
                this.hasScrolled();
                this.didScroll = false;
            }
        }, 250);
    }

    public toogle(): void {
        this.setState({ open: !this.state.open });

        this.props.toggledmobile();
    }

    public render(): JSX.Element {
        const toggleTitle = this.state.open ? 'Stäng meny' : 'Öppna meny';
        const icon = this.state.open ? 'close' : 'burger-menu';
        const iconText = this.state.open ? 'Stäng' : 'Meny';

        return (
            <button className="btn mobile-menu d-flex align-items-baseline" onClick={this.toogle.bind(this)} aria-haspopup="true">
                <span className="mobile-menu__text">{iconText}</span>
                <span className="mobile-menu__toggler-icon" title={toggleTitle}>
                    <Icon symbol={icon} />
                </span>
            </button>
        );
    }

    private hasScrolled() {
        const yScroll = window.pageYOffset;
        if (Math.abs(this.lastScrollTop - yScroll) <= this.delta) {
            return;
        }
        const headerElement = document.getElementsByClassName('header')[0];

        if (yScroll > this.lastScrollTop && yScroll > this.navbarHeight) {
            headerElement.classList.add('nav-up');
        } else {
            if (yScroll + document.body.clientHeight < document.body.scrollHeight) {
                headerElement.classList.remove('nav-up');
            }
        }

        this.lastScrollTop = yScroll;
    }
}
